import { Button, CustomerServiceCentre } from '@mobi/component-library/Common/V2'
import React from 'react'
import { useSelector } from 'react-redux'
import { getSignUpFailedType } from '../../Store'

export type FailedType = keyof typeof failedMessages

const failedMessages = {
  duplicateAccount: {
    header: 'Looks like you already have an account.',
    subHeader: (
      <CustomerServiceCentre
        prefixText='Please login to access your account. If you have any issues accessing your account,'
        suffixText='or use the button below.'
      />
    ),
    body: null,
    hasCallNowButton: true,
    hasBackToHomeButton: true,
  },
  closedAccount: {
    header: 'We were unable to verify your identity.',
    subHeader: (
      <CustomerServiceCentre
        prefixText={`Unfortunately we couldn't verify your identify with the details you provided,`}
        suffixText='or use the button below.'
      />
    ),
    body: null,
    hasCallNowButton: true,
    hasBackToHomeButton: false,
  },
  unverifiedUser: {
    header: 'We were unable to verify your identity.',
    subHeader: (
      <CustomerServiceCentre
        prefixText={`Unfortunately we couldn't verify your identify with the details you provided,`}
        suffixText='or use the button below.'
      />
    ),
    body: <div>'Please use reference blah'</div>,
    hasCallNowButton: true,
    hasBackToHomeButton: false,
  },
  sanctionedUser: {
    header: 'Your account is pending.',
    subHeader:
      'We were unable to verify your identity. Our team will review your application and contact you shortly.',
    body: null,
    hasCallNowButton: false,
    hasBackToHomeButton: true,
  },
}

export const FailedMessage = () => {
  const failedType = useSelector(getSignUpFailedType)

  if (!failedType) {
    return null
  }

  const failedMessage = failedMessages[failedType]

  return (
    <>
      <header>
        <h1>{failedMessage.header}</h1>
        <p>{failedMessage.subHeader}</p>
      </header>
      <body>{failedMessage.body}</body>
      <footer>
        {failedMessage.hasBackToHomeButton && <Button>Back to home</Button>}
        {failedMessage.hasCallNowButton && <Button>Call now</Button>}
      </footer>
    </>
  )
}
